import React, { FC } from "react";
import { useRecoilValue } from "recoil";
import storeConfigAtom from "~/services/store-config/store-config.atom";
import { replaceClassNames } from "~/utils/converters";
import styles from "./TopHeader.module.scss";

type TopHeaderProps = {
  storeConfigServerSide?: any;
};

const TopHeader: FC<TopHeaderProps> = ({ storeConfigServerSide }) => {
  const storeConfig = useRecoilValue(storeConfigAtom.store);
  return (
    <div>
      {(storeConfigServerSide ?? storeConfig)?.store_notice_enable && (
        <div
          dangerouslySetInnerHTML={{
            __html: replaceClassNames(
              (storeConfigServerSide ?? storeConfig).store_notice_message,
              {
                Header: styles,
              },
            ),
          }}
        />
      )}
    </div>
  );
};

export default TopHeader;
